export enum KnownInvoicesSortBy {
  InvoiceNumber,
  ShipmentNumber,
  OrderNumber,
  CustomerName,
  VendorName,
  Shipper,
  Consignee,
  ShipDate,
  CreatedDate,
  VendorInvoiceTypeDescription,
  VendorInvoiceStatusDescription,
  OwnerUser,
  VendorInvoiceStatusDateLastModified
}
